/**
 * External dependencies.
 */
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {registerLocale, setDefaultLocale} from "react-datepicker";
import de from 'date-fns/locale/de';
/**
 * Internal dependencies.
 */
import store from './store';
import Application from './containers/application';

registerLocale('de', de);
setDefaultLocale('de');
/**
 * Render the application.
 *
 * @return {void}
 */
const bootstrap = () => {
    console.log("ENV:", process.env);
    ReactDOM.render(
        <Provider store={store}>
            <Application/>
        </Provider>,
        document.getElementById('root')
    );
};

const setwindow = () => {
    window.open = window.cordova.InAppBrowser.open;
};

/**
 * Start!
 */
if (window.cordova) {
    document.addEventListener('deviceready', bootstrap, false);
    document.addEventListener('deviceready', setwindow, false);
} else {
    bootstrap();
}



// WEBPACK FOOTER //
// ./src/index.js